// BASED ON https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-plugin-google-tagmanager/

import { isStringPresent } from "@silversea-ssc/system-components-react/utils";
import { envVariableTrue } from "../env-variable-helpers";

const defaultDataLayer = {
  type: "object",
  value: { platform: "blog" }
};
const dataLayerName = `dataLayer`;
export const isTrackingEnabled = envVariableTrue(
  process.env.NEXT_PUBLIC_ENABLE_ANALYTICS
);

const environmentParamStr = ({
  gtmAuth,
  preview
}: {
  gtmAuth: string | undefined;
  preview: string | undefined;
}) => {
  return isStringPresent(preview)
    ? `&gtm_auth=${gtmAuth}&gtm_preview=${preview}&gtm_cookies_win=x`
    : ``;
};

export const generateGTM = ({
  gtmAuth,
  preview,
  gtmId
}: {
  gtmAuth: string | undefined;
  preview: string | undefined;
  gtmId: string;
}): string => `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl+'${environmentParamStr({ gtmAuth, preview })}';f.parentNode.insertBefore(j,f);
})(window,document,'script','${dataLayerName}', '${gtmId}');`;

export const generateGTMIframe = ({
  gtmAuth,
  preview,
  gtmId
}: {
  gtmAuth: string;
  preview: string;
  gtmId: string;
}): string =>
  `<iframe src="https://www.googletagmanager.com/ns.html?id=${
    gtmId
  }${environmentParamStr({ gtmAuth, preview })}" height="0" width="0" style="display: none; visibility: hidden" aria-hidden="true"></iframe>`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const generateDefaultDataLayer = (dataLayer: any, dataLayerName: string) => {
  let result = `window.${dataLayerName} = window.${dataLayerName} || [];`;

  if (dataLayer.type === `function`) {
    result += `window.${dataLayerName}.push((${dataLayer.value})());`;
  } else {
    if (dataLayer.type !== `object` || dataLayer.value.constructor !== Object) {
      console.error(
        `Oops the plugin option "defaultDataLayer" should be a plain object. "${dataLayer}" is not valid.`
      );
    }

    result += `window.${dataLayerName}.push(${JSON.stringify(dataLayer.value)});`;
  }

  return `${result}`;
};
export const defaultDataLayerCode = generateDefaultDataLayer(
  defaultDataLayer,
  dataLayerName
);
